import Joi from 'joi';

import { optionalString } from '../../../../../utils/validators';
import { FormValues } from './types';

export const TITLE_MAX_CHARACTERS = 140;

export const validationSchema = Joi.object<FormValues, true>({
  title: optionalString.max(TITLE_MAX_CHARACTERS),
});

export const finalValidationSchema = Joi.object<FormValues, true>({
  title: optionalString.max(TITLE_MAX_CHARACTERS),
});
